import React from 'react';
import styled from 'styled-components';
import RadioInputButton from '../RadioInputButton/RadioInputButton';

interface ShowHideToggleProps {
  showOverride?: string;
  hideOverride?: string;
  value: boolean;
  handleChange: (value: boolean) => void;
  dataTestId?: string;
  disabled?: boolean;
}

const ButtonWrapper = styled.div`
  display: flex;
`;

const ShowHideToggle: React.FC<ShowHideToggleProps> = ({
  value,
  handleChange,
  showOverride,
  hideOverride,
  dataTestId,
  disabled,
}) => {
  return (
    <ButtonWrapper>
      <RadioInputButton
        text={showOverride || 'Show'}
        active={value}
        marginRight="8px"
        onClick={(): void => handleChange(true)}
        dataTestId={`RadioInputButtonTrue-${dataTestId}`}
        disabled={disabled}
      />
      <RadioInputButton
        text={hideOverride || 'Hide'}
        active={!value}
        onClick={(): void => handleChange(false)}
        dataTestId={`RadioInputButtonFalse-${dataTestId}`}
        disabled={disabled}
      />
    </ButtonWrapper>
  );
};

ShowHideToggle.defaultProps = {
  showOverride: 'Show',
  hideOverride: 'Hide',
  dataTestId: '',
};

export default ShowHideToggle;
